import script from "./SideBarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarItem.vue?vue&type=script&setup=true&lang=js"

import "./SideBarItem.vue?vue&type=style&index=0&id=aec3d4bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aec3d4bc"]])

export default __exports__